import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c4875e1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20 p20"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb30"
}, "待办事项", -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_table, {
    data: $setup.data.list,
    border: ""
  }, {
    empty: _withCtx(() => [_createVNode(_component_el_empty, {
      description: "暂无数据"
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "orderNo",
      label: "运单号",
      width: "200"
    }, {
      default: _withCtx(scope => [_createElementVNode("p", null, _toDisplayString(scope.row.orderInfo?.orderNo), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "待办类型",
      "show-overflow-tooltip": "",
      width: "280"
    }, {
      default: _withCtx(scope => [_createElementVNode("p", null, _toDisplayString($setup.backlogTypeMap[scope.row.agendaType].text), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "运输起终点",
      "show-overflow-tooltip": "",
      width: "250"
    }, {
      default: _withCtx(scope => [scope.row.orderInfo ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.orderInfo?.loadingAddress) + " → " + _toDisplayString(scope.row.orderInfo?.unloadingAddress), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "运费(元)",
      width: "120"
    }, {
      default: _withCtx(scope => [scope.row.orderInfo ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.orderInfo?.amount / 100), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "货物",
      prop: "goodsName",
      width: "120"
    }, {
      default: _withCtx(scope => [scope.row.orderInfo ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.orderInfo?.goodsName), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "数量",
      width: "120"
    }, {
      default: _withCtx(scope => [scope.row.orderInfo ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${scope.row.orderInfo?.weight / 100}`), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "托运人"
    }, {
      default: _withCtx(scope => [scope.row.orderInfo ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.isPhoneNumber(scope.row.orderInfo?.forwarderName) ? $setup.phoneDesc(scope.row.orderInfo?.forwarderName) : $setup.EncryptName(scope.row.orderInfo?.forwarderName)), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      fixed: "right",
      label: "操作",
      width: "180"
    }, {
      default: _withCtx(scope => [scope.row.status ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        text: "",
        disabled: scope.row.status,
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString("已完成"))]),
        _: 2
      }, 1032, ["disabled"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [scope.row.agendaType == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_popconfirm, {
        title: "拒绝接取该运单?",
        placement: "top",
        "confirm-button-text": "确定",
        "cancel-button-text": "取消",
        onConfirm: () => $setup.handleAcceptChangeDriver(scope.row.agendaId, scope.row.relevanceId, 0)
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          text: "",
          type: "danger"
        }, {
          default: _withCtx(() => [_createTextVNode("否")]),
          _: 1
        })]),
        _: 2
      }, 1032, ["onConfirm"]), _createVNode(_component_el_popconfirm, {
        title: "同意接取该运单?",
        placement: "top"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          text: "",
          type: "success",
          "confirm-button-text": "确定",
          "cancel-button-text": "取消",
          onConfirm: () => $setup.handleAcceptChangeDriver(scope.row.agendaId, scope.row.relevanceId, 1)
        }, {
          default: _withCtx(() => [_createTextVNode("是")]),
          _: 2
        }, 1032, ["onConfirm"])]),
        _: 2
      }, 1024)])) : _createCommentVNode("", true), scope.row.agendaType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_button, {
        text: "",
        type: "primary",
        onClick: () => $setup.viewOrderDetail(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode("去签约")]),
        _: 2
      }, 1032, ["onClick"])])) : _createCommentVNode("", true), scope.row.agendaType == 5 || scope.row.agendaType == 4 ? (_openBlock(), _createElementBlock("view", _hoisted_11, [_createVNode(_component_el_popconfirm, {
        title: "确定拒绝?",
        "confirm-button-text": "确定",
        "cancel-button-text": "取消",
        placement: "top",
        onConfirm: () => $setup.agreeCancelOrder(scope.row, 0)
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          text: "",
          type: "danger"
        }, {
          default: _withCtx(() => [_createTextVNode("拒绝")]),
          _: 1
        })]),
        _: 2
      }, 1032, ["onConfirm"]), _createVNode(_component_el_popconfirm, {
        title: "确定同意?",
        "confirm-button-text": "确定",
        "cancel-button-text": "取消",
        placement: "top",
        onConfirm: () => $setup.agreeCancelOrder(scope.row, 1)
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          text: "",
          type: "success"
        }, {
          default: _withCtx(() => [_createTextVNode("同意")]),
          _: 1
        })]),
        _: 2
      }, 1032, ["onConfirm"])])) : _createCommentVNode("", true), scope.row.agendaType == 11 || scope.row.agendaType == 10 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        text: "",
        type: "primary",
        onClick: () => $setup.viewInvoiceManage(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode("前往结算管理")]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.agendaType != 4 && scope.row.agendaType != 5 && scope.row.agendaType != 11 && scope.row.agendaType != 10 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 4,
        text: "",
        type: "primary",
        onClick: () => $setup.viewOrderDetail(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode("前往订单详情")]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true)]))]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    "page-size": $setup.data.size,
    class: "mt20",
    background: "",
    layout: "pager,total",
    total: $setup.data.total,
    onCurrentChange: $setup.currentChange
  }, null, 8, ["page-size", "total", "onCurrentChange"])]);
}